"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const RadioTabPanel_1 = tslib_1.__importDefault(require("./RadioTabPanel"));
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated use {@link HorizontalViewTabCustomElement} {@link HorizontalValueTabCustomElement} instead
 */
class HasValueRadioTabPanel extends RadioTabPanel_1.default {
    constructor() {
        super(...arguments);
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
    }
    addTab(id, label, widget) {
        super.addTab(id, label, widget);
    }
    getValue() {
        if (this.selected) {
            return this.selected.widget.getValue();
        }
        return undefined;
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
}
exports.default = HasValueRadioTabPanel;
//# sourceMappingURL=HasValueRadioTabPanel.js.map